import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase'; // adjust path if necessary

const FAQ = () => {
  const [faqs, setFaqs] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    const fetchFAQs = async () => {
      const faqCollection = collection(db, 'faq');
      const faqSnapshot = await getDocs(faqCollection);
      const faqList = faqSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      setFaqs(faqList);
    };

    fetchFAQs();
  }, []);

  const toggleIndex = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="relative " id="faq">
      <div className="container mx-auto px-4 md:px-16 py-12 md:w-11/12 md:mt-0">
        <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-8 text-left ">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={faq.id} className="border rounded-lg shadow-sm">
              <button
                onClick={() => toggleIndex(index)}
                className="w-full text-left px-4 py-4 bg-white rounded-lg flex justify-between items-center"
              >
                <span className="text-base md:text-base text-gray-800 ">
                  {faq.question}
                </span>
                <span>{activeIndex === index ? '-' : '+'}</span>
              </button>
              {activeIndex === index && (
                <div className="px-4 py-4 bg-white text-gray-600 font-light border-t">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
